
















































































import Vue from "vue"
import LoginHeader from "@/components/header/LoginHeader.vue"
import { required, minLength, sameAs } from "vuelidate/lib/validators"
import { withParams } from "vuelidate/lib/withParams"

const strongPassword = withParams(
  { type: "strongPassword" },
  (value: string) => {
    if (!value) {
      return true
    }
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[{\]};:'",.<>/?\\|`~]).{8,}$/
    return regex.test(value)
  }
)

interface NewPasswordData {
  request: { password: string | null; repeatPassword: string | null }
  jwt: string
  errorMessage: string
}

export default Vue.extend({
  components: { LoginHeader },
  data(): NewPasswordData {
    return {
      request: {
        password: null,
        repeatPassword: null
      },
      jwt: "",
      errorMessage: ""
    }
  },
  validations: {
    request: {
      password: {
        required,
        minLength: minLength(8),
        strongPassword
      },
      repeatPassword: {
        sameAsPassword: sameAs("password")
      }
    }
  },
  methods: {
    submit() {
      const vm = this
      if (!vm.$v.$invalid) {
        vm.startLoad()
        vm.$http
          .post("/login/new",
            { password: vm.request.password },
            {
              headers: {
                "Authorization": "Bearer " + this.jwt
              }
            })
          .then(() => {
            vm.endLoad()
            vm.$router.push("/login")
          })
          .catch(e => {
            vm.errorMessage = e.message
            vm.endLoad()
          })
      }
    },
    getValidator(
      field: string,
      validation: string,
      i18nKey?: string
    ) {
      const vm = this

      return (rule: any, value: any, callback: any) => {
        const v = (vm.$v.request as any)[field]

        if (v.$dirty && !v[validation]) {
          const key = i18nKey || `login.validation.${field}.${validation}`
          callback(new Error(this.$t(key).toString()))
        } else {
          callback()
        }
      }
    }
  },
  computed: {
    rules(): any {
      const vm = this
      return {
        password: [
          { validator: vm.getValidator("password", "required"), trigger: "change" },
          {
            validator: vm.getValidator("password", "strongPassword", "user_administration.employee_password_invalid"),
            trigger: "change"
          }
        ],
        repeatPassword: [
          { validator: vm.getValidator("repeatPassword", "sameAsPassword"), trigger: "change" }
        ]
      }
    }
  },
  mounted(): void {
    this.jwt = this.$route.query.t as string
  }
})
